export default __webpack_public_path__ + "7aee2189c5a31056ebc81bd666f42438.png";